(function() {
  'use strict';

  // ── BUTIKSINSTÄLLNINGAR (från layout/theme.liquid) ──
  // Alla anrop till varukorgen går via butikens aktuella rot-URL
  // (t.ex. «/» eller «/sv-se/»). Annars kan Shopify svara med en annan
  // marknad/valuta än den sidan visas i – då skiljer sig priset i
  // varukorgen från priset på sidan (t.ex. 292 kr i stället för 299 kr).
  var NBT = window.NBTheme || {};
  function scRoot() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || NBT.root || '/';
    if (r.charAt(r.length - 1) !== '/') r += '/';
    return r;
  }
  function scUrl(path) { return scRoot() + path.replace(/^\//, ''); }

  // ── TOAST ──────────────────────────────────────
  function showToast(message) {
    var el = document.getElementById('nb-toast');
    if (!el) return;
    el.textContent = message;
    el.classList.add('visible');
    clearTimeout(el._timer);
    el._timer = setTimeout(function() { el.classList.remove('visible'); }, 3200);
  }

  // ── NAVIGATION ─────────────────────────────────
  function initNav() {
    var toggle = document.getElementById('nb-menu-toggle');
    var menu = document.getElementById('nb-nav-menu');
    if (!toggle || !menu) return;
    toggle.addEventListener('click', function() {
      var open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open);
    });
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.nb-nav')) menu.classList.remove('is-open');
    });
    menu.querySelectorAll('a').forEach(function(a) {
      a.addEventListener('click', function() { menu.classList.remove('is-open'); });
    });
  }

  // ── QUANTITY SELECTOR ──────────────────────────
  var currentVariantId = null;

  function initQtySelector() {
    // The homepage buy box (#nb-buy-options) manages its own click/select
    // logic in initBuyConfig() below (it also has to open/close a config
    // panel), so it's excluded here to avoid double-binding and to avoid
    // this generic selector auto-selecting the first option on load.
    var options = Array.prototype.slice.call(document.querySelectorAll('.nb-qty-option')).filter(function(o) {
      return !o.closest('#nb-buy-options');
    });
    if (!options.length) return;
    selectOption(options[0]);
    options.forEach(function(opt) {
      opt.addEventListener('click', function() { selectOption(opt); });
      opt.addEventListener('keydown', function(e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectOption(opt); } });
    });
  }

  function selectOption(opt) {
    var group = opt.closest('[role="radiogroup"]') || document;
    group.querySelectorAll('.nb-qty-option').forEach(function(o) {
      o.classList.remove('is-selected');
      o.setAttribute('aria-checked', 'false');
    });
    opt.classList.add('is-selected');
    opt.setAttribute('aria-checked', 'true');
    currentVariantId = opt.dataset.variantId || null;
  }

  // Swaps the small picker thumbnail (.sc-config-image img) to the
  // Hvit/Svart version matching the color button just clicked. Each
  // <img> carries its own data-white-src / data-black-src (set from
  // the merchant's own uploaded images in the theme editor), so every
  // unit — "1 stk", or either half of "2 stk" — swaps independently.
  // Crossfades via opacity so the swap reads as smooth/instant instead
  // of a hard flash, even though it's really a src change underneath.
  function scSwapConfigImage(colorBtn) {
    var configBox = colorBtn.closest('.sc-config');
    var img = configBox ? configBox.querySelector('.sc-config-image img') : null;
    if (!img) return;
    var isBlack = colorBtn.dataset.value === 'Svart';
    var newSrc = isBlack ? img.dataset.blackSrc : img.dataset.whiteSrc;
    if (!newSrc || img.src === newSrc) return;
    img.style.opacity = '0';
    var swap = function() {
      img.src = newSrc;
      img.style.opacity = '1';
    };
    // If the new image is already cached this resolves almost
    // immediately; either way the opacity transition covers the swap.
    var preload = new Image();
    preload.onload = swap;
    preload.onerror = swap;
    preload.src = newSrc;
  }

  // ── HOMEPAGE BUY-BOX CONFIG (Størrelse / Side / Farge) ──
  // The "produkt" landing page's buy box (#nb-buy-options in
  // homepage.liquid) keeps the Størrelse/Side/Farge fields hidden until
  // the customer picks "Stepcare (1 stk)" or "Stepcare (2 stk)": picking
  // "1 stk" reveals one shared set of fields, picking "2 stk" reveals two
  // independent sets (one per unit) side by side. Only one panel is ever
  // shown at a time. Purely presentational — the pack choice still drives
  // which real Shopify variant gets added — the picks are attached to
  // that line as line item properties so nothing selected is lost.
  function initBuyConfig() {
    var group = document.getElementById('nb-buy-options');
    if (!group) return;
    var options = Array.prototype.slice.call(group.querySelectorAll('.nb-qty-option'));
    if (!options.length) return;

    function closeAllPanels() {
      group.querySelectorAll('.sc-config-panel').forEach(function(p) { p.hidden = true; });
    }

    function syncTopPrice(opt) {
      var priceEl = opt.querySelector('.nb-qty-price');
      var wasEl = opt.querySelector('.nb-qty-original');
      var topNow = document.getElementById('nb-price-now');
      var topWas = document.getElementById('nb-price-was');
      var topPill = document.getElementById('nb-price-save-pill');
      if (topNow && priceEl) topNow.textContent = priceEl.textContent;
      if (topWas) {
        if (wasEl) { topWas.textContent = wasEl.textContent; topWas.hidden = false; }
        else { topWas.hidden = true; }
      }
      if (topPill) {
        if (wasEl && priceEl) {
          var was = parseFloat(wasEl.textContent.replace(/[^0-9.,]/g, '').replace(',', '.'));
          var now = parseFloat(priceEl.textContent.replace(/[^0-9.,]/g, '').replace(',', '.'));
          if (was > 0 && now >= 0 && was > now) {
            var pct = Math.round((was - now) / was * 100);
            topPill.textContent = '🏷️ SPARA ' + pct + '%';
            topPill.hidden = false;
          } else { topPill.hidden = true; }
        } else { topPill.hidden = true; }
      }
    }

    function select(opt) {
      options.forEach(function(o) {
        o.classList.remove('is-selected');
        o.setAttribute('aria-checked', 'false');
      });
      opt.classList.add('is-selected');
      opt.setAttribute('aria-checked', 'true');
      currentVariantId = opt.dataset.variantId || null;

      closeAllPanels();
      var panelId = opt.dataset.panel;
      var panel = panelId ? document.getElementById(panelId) : null;
      if (panel) panel.hidden = false;

      syncTopPrice(opt);
    }

    options.forEach(function(opt) {
      opt.addEventListener('click', function() { select(opt); });
      opt.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(opt); }
      });
    });

    // Color buttons inside either panel — scoped by data-unit so the two
    // "2 stk" units never affect each other's selected color.
    group.querySelectorAll('.sc-color-btn').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        var unit = btn.dataset.unit;
        group.querySelectorAll('.sc-color-btn[data-unit="' + unit + '"]').forEach(function(b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-checked', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-checked', 'true');
        scSwapConfigImage(btn);
      });
    });

    // Prevent a click inside a <select> (or its native dropdown) from
    // bubbling up and re-triggering the qty-option's own click handler.
    group.querySelectorAll('.sc-select').forEach(function(sel) {
      sel.addEventListener('click', function(e) { e.stopPropagation(); });
    });
  }

  function readBuyConfigProperties() {
    var group = document.getElementById('nb-buy-options');
    if (!group) return null;
    var openPanel = group.querySelector('.sc-config-panel:not([hidden])');
    if (!openPanel) return null;

    function readUnit(unit) {
      var sizeSel = openPanel.querySelector('.sc-select[data-unit="' + unit + '"][data-field="size"]');
      var sideSel = openPanel.querySelector('.sc-select[data-unit="' + unit + '"][data-field="side"]');
      var colorBtn = openPanel.querySelector('.sc-color-btn.is-active[data-unit="' + unit + '"]');
      return {
        size: sizeSel ? sizeSel.value : '',
        side: sideSel ? sideSel.value : '',
        color: colorBtn ? colorBtn.dataset.value : ''
      };
    }

    if (openPanel.querySelector('[data-unit="4a"]')) {
      var q1 = readUnit('4a'), q2 = readUnit('4b'), q3 = readUnit('4c'), q4 = readUnit('4d');
      return {
        'Storlek #1': q1.size,
        'Storlek #2': q2.size,
        'Storlek #3': q3.size,
        'Storlek #4': q4.size
      };
    }

    if (openPanel.querySelector('[data-unit="2a"]')) {
      var a = readUnit('2a'), b = readUnit('2b');
      return {
        'Storlek #1': a.size,
        'Storlek #2': b.size
      };
    }

    var u = readUnit('1');
    return { 'Storlek': u.size };
  }

  // ── SHOPIFY AJAX CART ──────────────────────────
  function addToCart() {
    if (!currentVariantId) { showToast('Välj ett alternativ!'); return; }
    var btn = document.getElementById('nb-atc-btn');
    var originalHtml = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Lägger till…'; }
    cartAdd(currentVariantId, 1, readBuyConfigProperties())
      .then(function() { showToast('✓ Tillagd i varukorgen!'); openCartDrawer(); })
      .catch(function(err) { showToast(err && err.message ? err.message : 'Något gick fel. Försök igen.'); })
      .finally(function() { if (btn) { btn.disabled = false; btn.innerHTML = originalHtml || '🛒 Lägg i varukorgen'; } });
  }

  // ── CART DRAWER ────────────────────────────────
  function openCartDrawer() {
    var backdrop = document.getElementById('nb-cart-backdrop');
    var drawer = document.getElementById('nb-cart-drawer');
    if (backdrop) backdrop.classList.add('is-open');
    if (drawer) drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }

  function closeCartDrawer() {
    var backdrop = document.getElementById('nb-cart-backdrop');
    var drawer = document.getElementById('nb-cart-drawer');
    if (backdrop) backdrop.classList.remove('is-open');
    if (drawer) drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  // ── STEPCARE BUNDLE LOGIC ───────────────────────
  // StepCare sells purchase options on one product: a single-unit
  // variant (any Størrelse × Side × Farge combo, all priced the same)
  // and dedicated "2 stk" / "3 stk" / "4 stk" bundle variants, each at
  // its own fixed (discounted) total price. Pressing "+" on a line at
  // quantity 1 steps it up the ladder — 1 → 2 → 3 → 4 — swapping to
  // the next dedicated variant each time, so the price always jumps
  // straight to the real tier price instead of just doubling. Once a
  // line is on the top "4 stk" tier (or there's no next tier to swap
  // to), "+" is a plain quantity increment like any other product line
  // — each further press adds one more whole 4-pack.
  // Everything here reads live prices/compare-at prices off the actual
  // Shopify variants (via /products/{handle}.js), so price edits made in
  // Shopify Admin are picked up automatically without touching this code.
  var BUNDLE_KEYWORDS = ['stepcare', 'stegfri', 'stryde', 'halstod', 'hälstöd', 'orthocare'];
  var productCache = {};   // handle -> product json (cached for the session)
  var lastCart = null;     // most recent /cart.js payload
  var cartOpLock = false;  // prevents overlapping +/- clicks mid-request

  function normalize(str) { return (str || '').toString().toLowerCase(); }

  function isKneeItem(item) {
    var handle = normalize(item.handle);
    var title = normalize(item.product_title);
    return title.indexOf('knä') !== -1 || handle.indexOf('kna') !== -1 || handle.indexOf('knee') !== -1;
  }

  function isBundleItem(item) {
    if (isKneeItem(item)) return false;
    var handle = normalize(item.handle);
    var title = normalize(item.product_title);
    return BUNDLE_KEYWORDS.some(function(k) { return handle.indexOf(k) !== -1 || title.indexOf(k) !== -1; });
  }

  function fetchProductData(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch(scUrl('products/' + encodeURIComponent(handle) + '.js'), { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(product) { productCache[handle] = product; return product; });
  }

  // ── Paketstege i varukorgen: 1 st → 2 st → 4 st ──────────────
  // Varje paket är en egen Shopify-variant med eget totalpris.
  // Varianterna hittas i den här ordningen:
  //   1. Variant-ID:n från köpboxen (sparas i webbläsaren när kunden
  //      varit på en sida med köpboxen – exakt samma som köpboxen använder)
  //   2. Siffran i variantnamnet: «1», «2 st», «4-pack», «4 stk» …
  //   3. Varianternas ordning (1:a, 2:a, 3:e)
  function scStoredTierIds() {
    var ids = null;
    var el = document.getElementById('sc-picker-data');
    if (el) {
      try {
        var d = JSON.parse(el.textContent);
        // Bara EGNA paketvarianter räknas som steg i stegen. Om «2 st»/«4 st»
        // saknar egen variant (tier: false) läggs 1 st-varianten med antal 2/4.
        var tierId = function(k) { return d[k] && d[k].id && (k === '1' || d[k].tier) ? d[k].id : null; };
        ids = { 1: tierId('1'), 2: tierId('2'), 3: tierId('3') };
        try { localStorage.setItem('scTierIds', JSON.stringify(ids)); } catch (e) {}
        return ids;
      } catch (e) {}
    }
    try { ids = JSON.parse(localStorage.getItem('scTierIds') || 'null'); } catch (e) { ids = null; }
    return ids;
  }

  function scPackFromTitle(title) {
    var t = normalize(title);
    var m = t.match(/(\d+)[\s-]*(st|stk|pack|pk|x|pcs|par)\b/);
    if (m) return parseInt(m[1], 10);
    m = t.match(/^\s*(\d+)\s*$/);
    if (m) return parseInt(m[1], 10);
    return null;
  }

  function scTiers(product) {
    var variants = (product && product.variants) || [];
    var byId = function(id) { return id ? variants.filter(function(v) { return v.id === Number(id); })[0] : null; };
    var tiers = { 1: null, 2: null, 3: null };
    var stored = scStoredTierIds();
    if (stored) { tiers[1] = byId(stored[1]); tiers[2] = byId(stored[2]); tiers[3] = byId(stored[3]); }
    [1, 2, 3].forEach(function(n) {
      if (tiers[n]) return;
      tiers[n] = variants.filter(function(v) { return scPackFromTitle(v.title) === n; })[0] || null;
    });
    // Ingen «3 st»-variant: en «4 st»-variant används som tredje paket.
    if (!tiers[3]) tiers[3] = variants.filter(function(v) { return scPackFromTitle(v.title) === 4; })[0] || null;
    // Ingen gissning på variantordning för 2 st / 4 st (det kunde lägga
    // fel variant och fel pris i varukorgen). Samma variant får aldrig
    // vara två olika steg.
    if (!tiers[1]) tiers[1] = variants.filter(function(v) { return v.available; })[0] || variants[0] || null;
    if (tiers[2] && tiers[1] && tiers[2].id === tiers[1].id) tiers[2] = null;
    if (tiers[3] && ((tiers[1] && tiers[3].id === tiers[1].id) || (tiers[2] && tiers[3].id === tiers[2].id))) tiers[3] = null;
    return tiers;
  }

  // pack: 2 eller 4 för paketvarianter, null för 1 st / okänd variant.
  function bundleInfoFromProduct(item, product) {
    var tiers = scTiers(product);
    if (tiers[3] && item.variant_id === tiers[3].id) return { pack: 3, variant: tiers[3], tiers: tiers };
    if (tiers[2] && item.variant_id === tiers[2].id) return { pack: 2, variant: tiers[2], tiers: tiers };
    return { pack: null, variant: null, tiers: tiers, isSingle: !!(tiers[1] && item.variant_id === tiers[1].id) };
  }

  // Bild i varukorgen: radens bild → produktens huvudbild → första
  // mediafilens förhandsbild → bilden från köpboxen på produktsidan.
  function scImgUrl(src) {
    if (!src) return null;
    if (typeof src === 'object') src = src.src || (src.preview_image && src.preview_image.src) || null;
    if (!src) return null;
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src;
  }

  function scCartImage(item, product) {
    var src = scImgUrl(item.image) || (item.featured_image && scImgUrl(item.featured_image.url));
    if (!src && product) {
      src = scImgUrl(product.featured_image);
      if (!src && product.media && product.media.length) {
        for (var i = 0; i < product.media.length && !src; i++) src = scImgUrl(product.media[i].preview_image || product.media[i].src);
      }
    }
    if (!src) {
      try {
        var stored = JSON.parse(localStorage.getItem('scPickerImage') || 'null');
        if (stored && stored.handle === item.handle) src = scImgUrl(stored.image);
      } catch (e) {}
    }
    // Produkten saknar egen bild i Shopify (bilderna ligger i temat):
    // använd bilden från köpboxen/galleriet på sidan, och sist bilden
    // som valts under Anpassa → Temainställningar → Varukorg.
    if (!src && scPickerData && scPickerData.handle === item.handle) src = scImgUrl(scPickerData.image);
    if (!src && isBundleItem(item)) src = scPageImage();
    if (!src) src = scImgUrl(NBT.cartImage);
    return src || null;
  }

  function scPageImage() {
    var el = document.getElementById('nb-main-img') ||
      document.querySelector('#nb-main-gallery img.nb-main-media') ||
      document.querySelector('.nb-gallery-thumb img');
    return el && el.getAttribute('src') ? scImgUrl(el.getAttribute('src')) : null;
  }

  function getBundleInfoSync(item) {
    if (!isBundleItem(item)) return null;
    var product = productCache[item.handle];
    if (!product) return null;
    return bundleInfoFromProduct(item, product);
  }

  function getBundleInfo(item) {
    if (!isBundleItem(item)) return Promise.resolve({ pack: null, variant: null, tiers: null });
    return fetchProductData(item.handle).then(function(product) { return bundleInfoFromProduct(item, product); });
  }

  // Storleksvalen följer med när raden byter paket. Går man upp kopieras
  // den senast valda storleken till de nya enheterna; går man ner tas
  // de sista bort.
  function scSizesFromProps(props) {
    var sizes = [];
    Object.keys(props || {}).forEach(function(k) {
      if (k === 'Storlek') sizes[0] = props[k];
      var m = k.match(/^Storlek #(\d+)$/);
      if (m) sizes[parseInt(m[1], 10) - 1] = props[k];
    });
    return sizes.filter(function(x) { return x; });
  }

  // Erbjudande «Köp X få X gratis»: kunden betalar för `count` st och får
  // lika många gratis, så antalet storlekar blir count × 2.
  function scBogoOn() { return !(window.NBTheme && window.NBTheme.bogo === false); }
  function scOfferText(paid) { return 'Köp ' + paid + ' få ' + paid + ' gratis (' + (paid * 2) + ' st totalt)'; }

  function scPropsForCount(props, count) {
    var out = {};
    Object.keys(props || {}).forEach(function(k) {
      if (k !== 'Storlek' && k !== 'Erbjudande' && !/^Storlek #\d+$/.test(k)) out[k] = props[k];
    });
    var sizes = scSizesFromProps(props);
    if (!sizes.length) return out;
    if (scBogoOn()) { out['Erbjudande'] = scOfferText(count); count = count * 2; }
    while (sizes.length < count) sizes.push(sizes[sizes.length - 1]);
    sizes = sizes.slice(0, count);
    if (count === 1) out['Storlek'] = sizes[0];
    else sizes.forEach(function(sz, i) { out['Storlek #' + (i + 1)] = sz; });
    return out;
  }

  function cartChange(key, quantity) {
    return fetch(scUrl('cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function(r) { return r.json(); });
  }

  function cartAdd(variantId, quantity, properties) {
    var payload = { id: parseInt(variantId, 10), quantity: quantity };
    if (properties && Object.keys(properties).length) payload.properties = properties;
    return fetch(scUrl('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data && data.status) { throw new Error(data.description || data.message || 'Kunde inte lägga till produkten'); }
      return data;
    });
  }

  function findCartItem(key) {
    return lastCart && lastCart.items.filter(function(i) { return i.key === key; })[0];
  }

  // Runs one cart mutation at a time, then always re-syncs from the real
  // Shopify cart (drawer, badge, total, and checkout all read from the
  // same refreshed state) before releasing the lock.
  function withCartLock(fn) {
    if (cartOpLock) return;
    cartOpLock = true;
    fn()
      .catch(function() { showToast('Något gick fel. Försök igen.'); })
      .then(function() { return refreshCart(); })
      .catch(function() {})
      .then(function() { cartOpLock = false; });
  }

  function scSwapLine(item, variant, count) {
    return cartChange(item.key, 0).then(function() {
      return cartAdd(variant.id, 1, scPropsForCount(item.properties || {}, count));
    });
  }

  // Rad utan egen paketvariant men med storleksval (t.ex. 1 st-varianten
  // med antal 2): byt antal och håll «Storlek #1, #2 …» i synk med antalet.
  function scResizeLine(item, newQty) {
    return cartChange(item.key, 0).then(function() {
      return cartAdd(item.variant_id, newQty, scPropsForCount(item.properties || {}, newQty));
    });
  }

  function scHasSizes(item) { return scSizesFromProps(item.properties || {}).length > 0; }

  // «+»: 1 st (399) → 2 st (599) → 3 st (749) → därefter ett helt 3-pack till per klick.
  function bundlePlus(key) {
    var item = findCartItem(key);
    if (!item) return;
    withCartLock(function() {
      return getBundleInfo(item).then(function(info) {
        var tiers = info.tiers;
        if (tiers && item.quantity === 1) {
          if (info.pack === null && tiers[2] && tiers[2].id !== item.variant_id) return scSwapLine(item, tiers[2], 2);
          if (info.pack === 2 && tiers[3]) return scSwapLine(item, tiers[3], 3);
        }
        if (info.pack === null && scHasSizes(item)) return scResizeLine(item, item.quantity + 1);
        return cartChange(key, item.quantity + 1);
      });
    });
  }

  // «−»: samma stege baklänges: 3 st → 2 st → 1 st.
  function bundleMinus(key) {
    var item = findCartItem(key);
    if (!item) return;
    withCartLock(function() {
      return getBundleInfo(item).then(function(info) {
        if (item.quantity > 1) {
          if (info.pack === null && scHasSizes(item)) return scResizeLine(item, item.quantity - 1);
          return cartChange(key, item.quantity - 1);
        }
        var tiers = info.tiers;
        if (tiers && info.pack === 3 && tiers[2]) return scSwapLine(item, tiers[2], 2);
        if (tiers && info.pack === 2 && tiers[1]) return scSwapLine(item, tiers[1], 1);
        return Promise.resolve(); // 1 st – ta bort med papperskorgen
      });
    });
  }

  function removeCartItem(key) {
    withCartLock(function() {
      return cartChange(key, 0).then(function() { showToast('Produkten togs bort'); });
    });
  }

  function refreshCart() {
    return fetch(scUrl('cart.js'), { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (NBT.currency && cart.currency && NBT.currency !== cart.currency && window.console) {
          console.warn('[Varukorg] Sidan visas i ' + NBT.currency + ' men varukorgen är i ' + cart.currency + '. Kontrollera Shopify → Marknader.');
        }
        renderCart(cart); return cart;
      })
      .catch(function() {});
  }

  var TRASH_ICON = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path><path d="M10 11v6"></path><path d="M14 11v6"></path><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"></path></svg>';

  function buildCartItemRow(item) {
    var info = getBundleInfoSync(item);
    var product = productCache[item.handle] || null;
    var imgSrc = scCartImage(item, product);
    var img = imgSrc ? '<img src="' + escapeHtml(imgSrc) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' : '<span style="font-size:24px">🛍️</span>';
    var liveVariant = product && product.variants ? product.variants.filter(function(v) { return v.id === item.variant_id; })[0] : null;
    var variantLabel = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
    if (info && variantLabel && scPackFromTitle(variantLabel) !== null) variantLabel = '';

    // Show any saved line item properties (Størrelse/Side/Farge, or the
    // "Produkt 1 – …"/"Produkt 2 – …" pairs for a 2 stk bundle line) so
    // the customer's choices are visibly carried into the cart.
    var propsHtml = '';
    if (item.properties) {
      var propLines = Object.keys(item.properties)
        .filter(function(k) { return k.charAt(0) !== '_' && k !== 'Erbjudande' && item.properties[k]; })
        .map(function(k) { return escapeHtml(k) + ': ' + escapeHtml(item.properties[k]); });
      if (propLines.length) {
        propsHtml = '<div class="nb-cart-item-props">' + propLines.join('<br>') + '</div>';
      }
    }

    var priceWasHtml = '';
    var savePillHtml = '';
    var packLabelHtml = '';
    // Radens slutpris = exakt det Shopify debiterar i kassan.
    var lineFinal = (item.final_line_price != null) ? item.final_line_price : item.line_price;
    var lineOriginal = (item.original_line_price != null) ? item.original_line_price : lineFinal;
    var priceNowHtml = formatPrice(lineFinal);
    var discountHtml = '';
    var minusDisabled = false;
    // The number shown in the stepper: for a bundle line this is the
    // real physical unit count (pack size × line quantity — e.g. one
    // "2 stk" line shows "2", not the underlying Shopify quantity of
    // 1), so it always matches what the customer is actually paying
    // for. For a plain line it's just the Shopify quantity as normal.
    var displayQuantity = item.quantity;

    // Jämförpris (överstruket) + «SPARA …» för alla rader där varianten har ett jämförpris.
    // Överstruket pris = det högsta av variantens jämförpris och
    // ordinarie pris före rabatt. Visas bara om det faktiskt är högre.
    // (Jämförpriset tas från varukorgsraden i första hand – samma valuta
    // som raden – och annars från produktdatan.)
    var unitCompare = item.compare_at_price || (liveVariant ? liveVariant.compare_at_price : null) || 0;
    var lineCompare = Math.max(unitCompare * item.quantity, lineOriginal);
    if (lineCompare > lineFinal) {
      var savings = lineCompare - lineFinal;
      priceWasHtml = '<span class="nb-cart-item-price-was">' + formatPrice(lineCompare) + '</span>';
      if (savings > 0) savePillHtml = '<div class="nb-cart-save-pill">SPARA ' + formatPrice(savings) + '</div>';
    }
    // Rabatter som Shopify har dragit av på raden (automatiska rabatter,
    // rabattkoder, appar) visas med namn så att priset aldrig «ändras»
    // utan förklaring.
    if (item.line_level_discount_allocations && item.line_level_discount_allocations.length) {
      discountHtml = '<div class="nb-cart-item-discounts">' + item.line_level_discount_allocations.map(function(d) {
        var t = (d.discount_application && d.discount_application.title) || 'Rabatt';
        return '🏷️ ' + escapeHtml(t) + ' (−' + formatPrice(d.amount) + ')';
      }).join('<br>') + '</div>';
    }

    if (info && info.pack && info.variant) {
      displayQuantity = info.pack * item.quantity;
      if (item.quantity > 1) packLabelHtml = '<div class="nb-cart-pack-label">' + item.quantity + ' × ' + info.pack + '-pack</div>';
      minusDisabled = false; // «−» går ner i stegen: 4 → 2 → 1
    } else {
      minusDisabled = item.quantity <= 1;
    }
    // «Köp X få X gratis»: visa de gratis skydden tydligt på raden.
    var giftHtml = '';
    if (scBogoOn() && item.properties && item.properties['Erbjudande']) {
      giftHtml = '<div class="nb-cart-gift">+ ' + displayQuantity + ' st gratis – du får ' + (displayQuantity * 2) + ' st</div>';
    }

    return '<div class="nb-cart-item" data-key="' + item.key + '">' +
      '<div class="nb-cart-item-img">' + img + '</div>' +
      '<div class="nb-cart-item-body">' +
        '<div class="nb-cart-item-top">' +
          '<div>' +
            '<div class="nb-cart-item-name">' + escapeHtml(item.product_title) + '</div>' +
            (variantLabel ? '<div class="nb-cart-item-variant">' + escapeHtml(variantLabel) + '</div>' : '') +
            propsHtml +
            discountHtml +
          '</div>' +
          '<button class="nb-cart-item-remove" onclick="NB.removeCartItem(\'' + item.key + '\')" aria-label="Ta bort">' + TRASH_ICON + '</button>' +
        '</div>' +
        '<div class="nb-cart-item-controls">' +
          '<div class="nb-cart-stepper">' +
            '<button type="button" ' + (minusDisabled ? 'disabled' : '') + ' onclick="NB.bundleMinus(\'' + item.key + '\')" aria-label="Minska antal">−</button>' +
            '<span class="nb-cart-stepper-count">' + displayQuantity + '</span>' +
            '<button type="button" onclick="NB.bundlePlus(\'' + item.key + '\')" aria-label="Öka antal">+</button>' +
          '</div>' +
          '<div class="nb-cart-item-pricing">' +
            priceWasHtml +
            '<span class="nb-cart-item-price-now">' + priceNowHtml + '</span>' +
            savePillHtml +
          '</div>' +
        '</div>' +
        packLabelHtml +
        giftHtml +
      '</div>' +
    '</div>';
  }

  // Briefly pulses the quantity count and price on ONE cart row so a
  // +/- click feels like a smooth live update instead of a hard swap.
  // Only touches that single row's number/price nodes — every other
  // row, image, and the rest of the page is left completely alone.
  function pulseQtyNodes(row) {
    if (!row) return;
    var nodes = [row.querySelector('.nb-cart-stepper-count'), row.querySelector('.nb-cart-item-price-now')];
    nodes.forEach(function(el) {
      if (!el) return;
      el.classList.remove('nb-qty-pulse');
      // Force reflow so the animation restarts if it's already running
      // (e.g. rapid repeated +/- clicks).
      void el.offsetWidth;
      el.classList.add('nb-qty-pulse');
    });
  }

  // Updates a single cart line's DOM node in place (count, price,
  // pack label, etc.) without rebuilding the rest of the cart body —
  // this is what keeps a plain +/- click smooth and avoids any
  // flicker on the other lines. Falls back to a full rebuild only if
  // the row can't be found (should not normally happen).
  function updateCartItemRow(body, item) {
    var row = body.querySelector('.nb-cart-item[data-key="' + item.key + '"]');
    if (!row) { body.innerHTML = lastCart.items.map(buildCartItemRow).join(''); return; }
    var oldCount = row.querySelector('.nb-cart-stepper-count');
    var oldCountText = oldCount ? oldCount.textContent : null;
    var temp = document.createElement('div');
    temp.innerHTML = buildCartItemRow(item);
    var newRow = temp.firstElementChild;
    row.replaceWith(newRow);
    var newCount = newRow.querySelector('.nb-cart-stepper-count');
    if (newCount && newCount.textContent !== oldCountText) pulseQtyNodes(newRow);
  }

  // ── Merförsäljning i varukorgen: knästöd «Lägg till» ──
  function updateUpsell(cart) {
    var box = document.getElementById('nb-cart-upsell');
    if (!box) return;
    var pid = parseInt(box.getAttribute('data-product-id'), 10);
    var inCart = cart.items.some(function(i) { return i.product_id === pid; });
    box.hidden = inCart;
  }

  function upsellVariantChange(sel) {
    var opt = sel.options[sel.selectedIndex];
    var box = document.getElementById('nb-cart-upsell');
    if (!box || !opt) return;
    var now = box.querySelector('.nb-upsell-price-now');
    var was = box.querySelector('.nb-upsell-price-was');
    if (now) now.textContent = opt.getAttribute('data-price');
    if (was) { var w = opt.getAttribute('data-was'); was.textContent = w || ''; was.hidden = !w; }
  }

  function addUpsell(btn) {
    var box = document.getElementById('nb-cart-upsell');
    if (!box) return;
    var sel = box.querySelector('.nb-upsell-select');
    var variantId = sel ? sel.value : box.getAttribute('data-variant-id');
    if (!variantId) return;
    btn.disabled = true;
    var oldText = btn.textContent;
    btn.textContent = '…';
    cartAdd(variantId, 1)
      .then(function() { showToast('✓ Tillagd i varukorgen!'); return refreshCart(); })
      .catch(function() { showToast('Något gick fel. Försök igen.'); })
      .then(function() { btn.disabled = false; btn.textContent = oldText; });
  }

  function renderCart(cart) {
    var previousCart = lastCart;
    lastCart = cart;
    updateUpsell(cart);
    document.querySelectorAll('.nb-cart-badge').forEach(function(el) {
      el.textContent = cart.item_count;
    });
    var body = document.getElementById('nb-cart-body');
    var footer = document.getElementById('nb-cart-footer');
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="nb-cart-empty"><div class="nb-cart-empty-icon">🛍️</div><p style="font-weight:600;margin-bottom:6px">Din varukorg är tom</p><p style="font-size:13px">Lägg till produkter för att börja handla</p></div>';
      if (footer) footer.style.display = 'none';
      return;
    }
    if (footer) {
      footer.style.display = 'block';
      var totalEl = document.getElementById('nb-cart-total-price');
      if (totalEl) totalEl.textContent = formatPrice(cart.total_price, cart.currency);
      // Rabatt på hela ordern (t.ex. rabattkod) visas som egen rad.
      var cartDiscount = 0;
      (cart.cart_level_discount_applications || []).forEach(function(d) { cartDiscount += (d.total_allocated_amount || 0); });
      var discRow = document.getElementById('nb-cart-discount');
      var discAmt = document.getElementById('nb-cart-discount-amount');
      if (discRow && discAmt) {
        if (cartDiscount > 0) { discAmt.textContent = '−' + formatPrice(cartDiscount, cart.currency); discRow.hidden = false; }
        else { discRow.hidden = true; }
      }
    }
    // Same lines, same order, just a quantity change (the normal +/-
    // click) → update each row in place further down. Any other change
    // (item added/removed, or a 1→2 bundle variant swap) still gets the
    // full rebuild, since the row layout itself is different then.
    var sameLines = !!previousCart &&
      previousCart.items.length === cart.items.length &&
      previousCart.items.every(function(pItem, idx) {
        return cart.items[idx] && cart.items[idx].key === pItem.key;
      });
    // Warm the product-json cache for every bundle handle in the cart
    // (usually just one product), then build all rows synchronously so
    // pack labels/compare-at prices are accurate from the first paint.
    var handles = [];
    cart.items.forEach(function(item) {
      if ((isBundleItem(item) || !item.image) && handles.indexOf(item.handle) === -1) handles.push(item.handle);
    });
    Promise.all(handles.map(fetchProductData))
      .catch(function() {})
      .then(function() {
        if (sameLines) {
          cart.items.forEach(function(item) { updateCartItemRow(body, item); });
        } else {
          body.innerHTML = cart.items.map(buildCartItemRow).join('');
        }
      });
  }

  // ── GALLERY (images + video/model slides) ───────
  function initGallery() {
    var mainGallery = document.getElementById('nb-main-gallery');
    if (!mainGallery) return;
    var slides = Array.prototype.slice.call(mainGallery.querySelectorAll('.nb-gallery-slide'));
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('.nb-gallery-thumb'));
    if (!slides.length) return;

    function stopMedia(slide) {
      var video = slide.querySelector('video');
      if (video) { try { video.pause(); } catch (e) {} }
      var iframe = slide.querySelector('iframe');
      if (iframe) {
        var src = iframe.getAttribute('src');
        if (src) { iframe.setAttribute('src', src); }
      }
    }

    function activate(index) {
      if (index < 0 || index >= slides.length) return;
      slides.forEach(function(slide, i) {
        if (i === index) {
          slide.classList.add('is-active');
        } else {
          if (slide.classList.contains('is-active')) { stopMedia(slide); }
          slide.classList.remove('is-active');
        }
      });
      thumbs.forEach(function(t) { t.classList.remove('is-active'); });
      if (thumbs[index]) { thumbs[index].classList.add('is-active'); }
    }

    thumbs.forEach(function(thumb, index) {
      thumb.addEventListener('click', function() { activate(index); });
      thumb.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(index); }
      });
    });

    function currentIndex() {
      var i = slides.findIndex(function(s) { return s.classList.contains('is-active'); });
      return i === -1 ? 0 : i;
    }

    document.querySelectorAll('.nb-gallery-arrow--prev').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var i = currentIndex();
        activate((i - 1 + slides.length) % slides.length);
      });
    });
    document.querySelectorAll('.nb-gallery-arrow--next').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var i = currentIndex();
        activate((i + 1) % slides.length);
      });
    });
  }

  // ── SIMPLE GALLERY (single main image + thumbnail swap) ──
  // Used on pages built from the "homepage" section (e.g. /pages/produkt),
  // which renders one <img id="nb-main-img"> plus thumbnails carrying
  // data-src/data-alt, instead of the slide-based gallery above. The two
  // galleries use different markup, so they need separate init logic.
  function initSimpleGallery() {
    var mainImg = document.getElementById('nb-main-img');
    var wrap = document.getElementById('nb-gallery-main');
    if (!mainImg || !wrap) return;
    var thumbs = Array.prototype.slice.call(wrap.parentNode.querySelectorAll('.nb-gallery-thumb[data-src]'));
    if (!thumbs.length) return;

    function activate(index) {
      if (index < 0 || index >= thumbs.length) return;
      var thumb = thumbs[index];
      mainImg.setAttribute('src', thumb.getAttribute('data-src'));
      mainImg.setAttribute('alt', thumb.getAttribute('data-alt') || mainImg.getAttribute('alt'));
      thumbs.forEach(function(t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    }

    thumbs.forEach(function(thumb, index) {
      thumb.addEventListener('click', function() { activate(index); });
      thumb.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(index); }
      });
    });

    function currentIndex() {
      var i = thumbs.findIndex(function(t) { return t.classList.contains('is-active'); });
      return i === -1 ? 0 : i;
    }

    Array.prototype.slice.call(wrap.querySelectorAll('.nb-gallery-arrow--prev')).forEach(function(btn) {
      btn.addEventListener('click', function() {
        var i = currentIndex();
        activate((i - 1 + thumbs.length) % thumbs.length);
      });
    });
    Array.prototype.slice.call(wrap.querySelectorAll('.nb-gallery-arrow--next')).forEach(function(btn) {
      btn.addEventListener('click', function() {
        var i = currentIndex();
        activate((i + 1) % thumbs.length);
      });
    });
  }

  // ── COLOR PICKER ─────────────────────────────────
  function initColorPicker() {
    document.querySelectorAll('.nb-color-row').forEach(function(row) {
      var swatches = Array.prototype.slice.call(row.querySelectorAll('.nb-color-swatch'));
      var label = row.querySelector('.nb-color-selected');
      swatches.forEach(function(btn) {
        btn.addEventListener('click', function() {
          swatches.forEach(function(b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-checked', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-checked', 'true');
          if (label) { label.textContent = btn.dataset.colorValue; }
        });
      });
    });
  }

  // ── STEPCARE KÖPBOX (svenska) ─────────────────
  // Tre kort: «1 st», «2 st» och «4 st». Det valda kortet fälls ut och
  // visar en storleksväljare per skydd (#1, #2 …). Varje alternativ
  // lägger alltid till EN enhet av sin egen Shopify-variant (priset
  // läses live från varianten), och storlekarna följer med som
  // radegenskaper på varukorgsraden.
  var scPickerData = null;
  var scSelected = '1';

  function scSetOptional(el, text) {
    if (!el) return;
    if (text) { el.textContent = text; el.hidden = false; }
    else { el.hidden = true; el.textContent = ''; }
  }

  function scUpdatePriceDisplay() {
    if (!scPickerData) return;
    var active = scPickerData[scSelected];
    if (!active) return;
    var atcPrice = document.querySelector('[data-atc-price]');
    var atcWas = document.querySelector('[data-atc-was]');
    if (atcPrice) atcPrice.textContent = active.price;
    scSetOptional(atcWas, active.compareAt);
    var topNow = document.getElementById('nb-price-now');
    var topWas = document.getElementById('nb-price-was');
    var topPill = document.getElementById('nb-price-save-pill');
    if (topNow) topNow.textContent = active.price;
    scSetOptional(topWas, active.compareAt);
    scSetOptional(topPill, active.pct > 0 ? ('🏷️ SPARA ' + active.pct + '%') : null);
  }

  function scSelectOption(root, optionValue) {
    scSelected = optionValue;
    root.querySelectorAll('.scx-option').forEach(function(el) {
      var active = el.dataset.option === optionValue;
      el.classList.toggle('is-selected', active);
      el.setAttribute('aria-checked', active ? 'true' : 'false');
      var body = el.querySelector('.scx-body');
      if (body) body.hidden = !active;
    });
    scUpdatePriceDisplay();
  }

  function initStepcarePicker() {
    var root = document.getElementById('sc-picker');
    var dataEl = document.getElementById('sc-picker-data');
    if (!root || !dataEl) return;
    try { scPickerData = JSON.parse(dataEl.textContent); } catch (e) { scPickerData = null; }
    if (!scPickerData) return;
    if (!scPickerData.image) scPickerData.image = scPageImage();
    if (scPickerData.image) {
      try { localStorage.setItem('scPickerImage', JSON.stringify({ handle: scPickerData.handle, image: scPickerData.image })); } catch (e) {}
    }
    scStoredTierIds();

    root.querySelectorAll('.scx-option').forEach(function(el) {
      el.addEventListener('click', function(e) {
        if (e.target.closest('select')) return;
        if (el.dataset.option !== scSelected) scSelectOption(root, el.dataset.option);
      });
      el.addEventListener('keydown', function(e) {
        if (e.target !== el) return; // låt Enter/Mellanslag i en <select> fungera som vanligt
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); scSelectOption(root, el.dataset.option); }
      });
    });
    root.querySelectorAll('.scx-select').forEach(function(sel) {
      sel.addEventListener('click', function(e) { e.stopPropagation(); });
    });

    scSelectOption(root, '1');
  }

  function scReadSizes(root, optionValue) {
    var props = {};
    var selects = root.querySelectorAll('.scx-select[data-option="' + optionValue + '"]');
    if (selects.length === 1) {
      props['Storlek'] = selects[0].value;
    } else {
      selects.forEach(function(sel) { props['Storlek #' + sel.dataset.unit] = sel.value; });
    }
    return props;
  }

  function addToCartStepcare() {
    var root = document.getElementById('sc-picker');
    if (!root || !scPickerData) { showToast('Kunde inte ladda köpboxen. Ladda om sidan och försök igen.'); return; }
    var active = scPickerData[scSelected];
    if (!active || !active.id) { showToast('Paketet är inte kopplat till någon variant ännu.'); return; }
    var btn = document.getElementById('nb-atc-btn');
    var originalHtml = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Lägger till…'; }

    var scProps = scReadSizes(root, scSelected);
    if (scBogoOn()) scProps = Object.assign({ 'Erbjudande': scOfferText(parseInt(scSelected, 10) || 1) }, scProps);
    cartAdd(active.id, active.qty || 1, scProps)
      .then(function(added) {
        // Kontroll: samma pris i varukorgen som i köpboxen?
        if (added && active.cents && added.original_price != null && added.original_price * (active.qty || 1) !== active.cents && window.console) {
          console.warn('[Varukorg] Köpboxen visar ' + active.price + ' men Shopify lade in ' + formatPrice(added.original_price * (active.qty || 1)) + '. Kontrollera variantens pris/marknad i Shopify Admin.');
        }
        showToast('✓ Tillagd i varukorgen!'); openCartDrawer();
      })
      .catch(function(err) { showToast(err && err.message ? err.message : 'Något gick fel. Försök igen.'); })
      .finally(function() { if (btn) { btn.disabled = false; btn.innerHTML = originalHtml; } });
  }

  // ── FAQ ────────────────────────────────────────
  function initFaq() {
    document.querySelectorAll('.nb-faq-question').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = btn.closest('.nb-faq-item');
        if (item) item.classList.toggle('is-open');
      });
    });
  }

  // ── ORDER TRACKING ─────────────────────────────
  function trackOrder() {
    var input = document.getElementById('nb-track-input');
    var result = document.getElementById('nb-track-result');
    if (!input || !result) return;
    var val = input.value.trim();
    if (!val) { showToast('Skriv in ett ordernummer'); return; }
    var steps = [
      { label: 'Order mottagen', time: '3 dagar sedan', done: true },
      { label: 'Packad på lagret', time: '2 dagar sedan', done: true },
      { label: 'Skickad med PostNord', time: 'Igår kl. 14:22', done: true },
      { label: 'På väg till dig', time: 'Väntas idag', done: false, current: true },
      { label: 'Levererad', time: 'Väntas imorgon', done: false }
    ];
    result.innerHTML = '<p style="font-weight:600;font-size:14px;margin-bottom:12px">Order: ' + escapeHtml(val) + '</p>' +
      steps.map(function(s) {
        var cls = 'nb-track-dot' + (s.done ? ' is-done' : '') + (s.current ? ' is-current' : '');
        return '<div class="nb-track-step"><div class="' + cls + '"></div><div class="nb-track-info"><strong>' + s.label + '</strong><span>' + s.time + '</span></div></div>';
      }).join('');
    result.classList.add('is-visible');
  }

  // ── REVIEW FORM ─────────────────────────────────
  function initReviewStars() {
    var stars = document.querySelectorAll('.nb-star-input');
    var rating = 0;
    stars.forEach(function(star) {
      star.addEventListener('click', function() {
        rating = parseInt(star.dataset.star);
        stars.forEach(function(s) {
          s.classList.toggle('is-active', parseInt(s.dataset.star) <= rating);
        });
      });
      star.addEventListener('mouseenter', function() {
        var hover = parseInt(star.dataset.star);
        stars.forEach(function(s) {
          s.style.color = parseInt(s.dataset.star) <= hover ? '#f59e0b' : '';
        });
      });
      star.addEventListener('mouseleave', function() {
        stars.forEach(function(s) {
          s.style.color = s.classList.contains('is-active') ? '#f59e0b' : '';
        });
      });
    });
  }

  function submitReview() {
    var name = document.getElementById('review-name');
    var text = document.getElementById('review-text');
    var activeStars = document.querySelectorAll('.nb-star-input.is-active').length;
    if (!name || !name.value.trim()) { showToast('Skriv ditt namn'); return; }
    if (activeStars === 0) { showToast('Välj ett betyg'); return; }
    if (!text || !text.value.trim()) { showToast('Skriv din recension'); return; }
    showToast('✓ Tack för din recension! Den granskas och publiceras snart.');
    document.getElementById('nb-review-form').classList.remove('is-visible');
    if (name) name.value = '';
    if (text) text.value = '';
    document.querySelectorAll('.nb-star-input').forEach(function(s) { s.classList.remove('is-active'); });
  }

  // ── UTILS ──────────────────────────────────────
  // Formaterar ett belopp i ören (som Shopify Ajax Cart API returnerar,
  // t.ex. /cart.js) i varukorgens EGEN valuta: «299,00 kr».
  // Valutan tas från varukorgen (cart.currency) så att beloppet aldrig
  // får fel valutaetikett – tidigare stod det alltid «kr» oavsett valuta.
  function formatPrice(cents, currency) {
    var amount = (Number(cents) || 0) / 100;
    var cur = currency || (lastCart && lastCart.currency) || NBT.currency || 'SEK';
    try {
      return new Intl.NumberFormat('sv-SE', {
        style: 'currency',
        currency: cur,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (e) {
      return amount.toFixed(2).replace('.', ',') + (cur === 'SEK' ? ' kr' : ' ' + cur);
    }
  }
  function escapeHtml(str) {
    if (!str) return '';
    return str.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  // ── PUBLIC API ──────────────────────────────────
  window.NB = {
    addToCart: addToCart,
    addToCartStepcare: addToCartStepcare,
    openCartDrawer: openCartDrawer,
    closeCartDrawer: closeCartDrawer,
    addUpsell: addUpsell,
    upsellVariantChange: upsellVariantChange,
    removeCartItem: removeCartItem,
    bundlePlus: bundlePlus,
    bundleMinus: bundleMinus,
    trackOrder: trackOrder,
    submitReview: submitReview,
    showToast: showToast
  };

  // ── COUNTDOWN BAR ──────────────────────────────
  // Rolling countdown (length set in Customizer → Theme settings, default
  // 21h). The deadline is stored in localStorage so a page reload doesn't
  // reset the timer; once it reaches zero it restarts automatically. All
  // ".nb-countdown-bar" instances on the page (homepage + product page)
  // stay in sync with the same clock. If the bar is turned off in the
  // Customizer it simply isn't in the page, so this does nothing.
  function initCountdown() {
    var bars = document.querySelectorAll('.nb-countdown-bar');
    if (!bars.length) return;
    var STORAGE_KEY = 'nb_sale_deadline';
    var hours = parseFloat(bars[0].dataset.hours) || 21;
    var DURATION = hours * 60 * 60 * 1000;
    var deadline;
    try { deadline = parseInt(localStorage.getItem(STORAGE_KEY), 10); } catch (e) { deadline = NaN; }
    var now = Date.now();
    if (!deadline || isNaN(deadline) || deadline <= now) {
      deadline = now + DURATION;
      try { localStorage.setItem(STORAGE_KEY, deadline); } catch (e) {}
    }

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function tick() {
      var diff = deadline - Date.now();
      if (diff <= 0) {
        deadline = Date.now() + DURATION;
        try { localStorage.setItem(STORAGE_KEY, deadline); } catch (e) {}
        diff = deadline - Date.now();
      }
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      bars.forEach(function (bar) {
        var hEl = bar.querySelector('.nb-countdown-h');
        var mEl = bar.querySelector('.nb-countdown-m');
        var sEl = bar.querySelector('.nb-countdown-s');
        if (hEl) hEl.textContent = pad(h);
        if (mEl) mEl.textContent = pad(m);
        if (sEl) sEl.textContent = pad(s);
      });
    }

    tick();
    setInterval(tick, 1000);
  }

  // ── SOCIAL PROOF (viewer count) ─────────────────
  // Cycles the "X personer ser på dette produktet" number between 11
  // and 25 every 15 seconds. Each tick picks a fresh random value in that
  // range (not a running total), so it naturally drifts up and down.
  function initSocialProof() {
    var counters = document.querySelectorAll('.nb-viewers-count');
    if (!counters.length) return;

    var MIN_VIEWERS = 6;
    var MAX_VIEWERS = 14;
    var UPDATE_MS = 15000;

    function randomViewers() {
      return Math.floor(Math.random() * (MAX_VIEWERS - MIN_VIEWERS + 1)) + MIN_VIEWERS;
    }

    counters.forEach(function (el) {
      el.textContent = randomViewers();
    });

    setInterval(function () {
      counters.forEach(function (el) {
        el.textContent = randomViewers();
      });
    }, UPDATE_MS);
  }

  // ── INIT ────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function() {
    initNav();
    initQtySelector();
    initGallery();
    initSimpleGallery();
    initColorPicker();
    initStepcarePicker();
    initBuyConfig();
    initFaq();
    initReviewStars();
    initCountdown();
    initSocialProof();
    refreshCart();

    var backdrop = document.getElementById('nb-cart-backdrop');
    if (backdrop) backdrop.addEventListener('click', closeCartDrawer);
  });

})();
